import { Lesson } from '@/app/entities/Training'
import useGetTrainingById from '@/app/hooks/useGetTrainingById'
import { BasicTable } from '@/view/components/BasicTable'
import { Spinner } from '@/view/components/ui/spinner'
import { useParams } from 'react-router-dom'
import { useTrainingDetailsTable } from '../hooks/useTraningDetailsTable'
import { DeleteTrainingProvider } from '../providers/DeleteTrainingProvider'
import { TrainingFormProvider } from '../providers/TraningFormProvider'
import { TrainingDetailsHeader } from './components/TrainingDetailsHeader'

export const TrainingDetails = () => {
  const { id } = useParams<{ id: string }>()

  const {
    data: training,
    isLoading,
    isError,
    error,
    isFetching,
  } = useGetTrainingById(id!)

  const table = useTrainingDetailsTable({
    lessons: training?.lessons || [],
    trainingId: id!,
  })

  if (isLoading || isFetching) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (isError) {
    return <p>{error.message}</p>
  }

  if (!training) {
    return <p>Erro ao carregar treinamento</p>
  }

  return (
    <div className="w-full">
      <TrainingFormProvider>
        <DeleteTrainingProvider>
          <TrainingDetailsHeader training={training} />
        </DeleteTrainingProvider>
      </TrainingFormProvider>
      <div className="mt-5">
        <BasicTable<Lesson>
          getPageCount={() => 1}
          getPageIndex={() => 1}
          handleNextPage={() => {}}
          handlePreviousPage={() => {}}
          table={table}
          type="table with lines"
          headerClassName="bg-[#F7F7F7] py-6"
        />
      </div>
    </div>
  )
}
